export class ModalRemoverEncomendaController {
  constructor($scope, $uibModalInstance, remessa, msgLabelPrinted) {
    'ngInject';

    $scope.showMsg = msgLabelPrinted;
    $scope.remessa = remessa;

    $scope.nao = function() {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.sim = function() {
      $uibModalInstance.close($scope.remessa);
    };
  }
}
